import React from 'react'
import PropTypes from 'prop-types'

import ActionButton from './ActionButton'
import CompositeVertical from './CompositeVertical'
import CompositeHorizontal from './CompositeHorizontal'
import CategoryCheckbox from './CategoryCheckbox'
import CountryChooser from './CountryChooser'
import FlatButton from './FlatButton'
import Hours from './Hours'
import Image from './Image'
import Text from './Text'

class View extends React.Component {

  static conditionsAreMet (config, functions, poi) {
    if (config.condition) {
      return functions.eval(config.condition, poi)
    }
    return true
  }

  renderActionButton () {
    return (
      <ActionButton
        config={this.props.config}
        functions={this.props.functions}
        poi={this.props.poi}
        setCategoryVisible={this.props.setCategoryVisible}
      />
    )
  }

  renderCategoryCheckbox () {
    return (
      <CategoryCheckbox
        config={this.props.config}
        functions={this.props.functions}
        poi={this.props.poi}
        filterSettings={this.props.filterSettings}
        setCategoryVisible={this.props.setCategoryVisible}
      />
    )
  }

  renderCompositeHorizontal () {
    return (
      <CompositeHorizontal
        config={this.props.config}
        functions={this.props.functions}
        poi={this.props.poi}
        filterSettings={this.props.filterSettings}
        setCategoryVisible={this.props.setCategoryVisible}
        setSelectedCountry={this.props.setSelectedCountry}
      />
    )
  }

  renderCompositeVertical () {
    return (
      <CompositeVertical
        config={this.props.config}
        functions={this.props.functions}
        poi={this.props.poi}
        filterSettings={this.props.filterSettings}
        setCategoryVisible={this.props.setCategoryVisible}
        setSelectedCountry={this.props.setSelectedCountry}
      />
    )
  }

  renderCountryChooser () {
    return (
      <CountryChooser
        config={this.props.config}
        functions={this.props.functions}
        poi={this.props.poi}
        setSelectedCountry={this.props.setSelectedCountry}
      />
    )
  }

  renderFlatButton () {
    return (
      <FlatButton
        config={this.props.config}
        functions={this.props.functions}
        poi={this.props.poi}
        setCategoryVisible={this.props.setCategoryVisible}
      />
    )
  }

  renderHours () {
    return (
      <Hours
        config={this.props.config}
        functions={this.props.functions}
        poi={this.props.poi}
      />
    )
  }

  renderImage () {
    return (
      <Image
        config={this.props.config}
        functions={this.props.functions}
        poi={this.props.poi}
      />
    )
  }

  renderText () {
    return (
      <Text
        config={this.props.config}
        functions={this.props.functions}
        poi={this.props.poi}
      />
    )
  }

  renderNotYetSupported (type) {
    return (
      <span>
        Not yet supported: {type}
      </span>
    )
  }

  render () {
    if (!this.props.config) {
      return null
    }
    switch (this.props.config.type) {
      case Text.TYPE:
        return this.renderText()

      case Image.TYPE:
        return this.renderImage()

      case ActionButton.TYPE:
        return this.renderActionButton()

      case FlatButton.TYPE:
        return this.renderFlatButton()

      case CategoryCheckbox.TYPE:
        return this.renderCategoryCheckbox()

      case CompositeVertical.TYPE:
        return this.renderCompositeVertical()

      case CompositeHorizontal.TYPE:
        return this.renderCompositeHorizontal()

      case Hours.TYPE:
        return this.renderHours()

      case CountryChooser.TYPE:
        return this.renderCountryChooser()

      default:
        return this.renderNotYetSupported(this.props.config.type)
    }
  }

}

View.propTypes = {
  config: PropTypes.object.isRequired,
  functions: PropTypes.object.isRequired,
  poi: PropTypes.object,
  filterSettings: PropTypes.object,
  setCategoryVisible: PropTypes.func,
  setSelectedCountry: PropTypes.func
}

View.defaultProps = {
  poi: null
}

export default View



// WEBPACK FOOTER //
// ./src/components/ViewComponents/View.js